module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112214741.b0839a9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112214741.jpg
// module id = 40
// module chunks = 0